import { defineComponent } from 'vue'
import { RouterView } from 'vue-router'
import './DebitCardRouterView.scss'

/** 云算力路由 */
const DebitCardRouterView = defineComponent({
  name: 'DebitCardRouterView',
  setup() {
    return () => (
      <div class="debit-card-router-layout">
        <RouterView />
      </div>
    )
  },
})

export default DebitCardRouterView
